import React, { useEffect } from "react";
import MyButton1 from "./CustomComponents/MyButton1";
import config from "../config";
import {
  CssBaseline,
  Stack,
  IconButton,
  Typography,
  Container,
} from "@mui/material";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ConfirmDialog } from "primereact/confirmdialog";

import "./eventComponent/EventTabs/EventTabs.css";
import { homePagePath } from "../constant";
import Navbar from "../redesign/components/Navbar";
import Footer from "../redesign/components/Footer";
import { getRegionContactInfo } from "../util/contactRegion";

export const Shipping_DeliveryPolicy = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const activeContactInfo = config.isIndia ? config.contactInfo?.india : config.contactInfo?.usa;
  const phoneNumber = activeContactInfo?.phone || "";
  const emailAddress = activeContactInfo?.email || "";

  const backtoHome = () => {
    navigate(isLoggedIn ? "/dashboard" : homePagePath);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <CssBaseline />
      <Navbar />

      <div className={`main-container ${!isLoggedIn ? "no-auth" : ""}`}>
        <div className="event-service-head-inner-policy">
          {/* <IconButton
                  onClick={backtoHome}
                  style={{
                    backgroundColor: "#0cc0df",
                    color: "#fff",
                    padding: "8px",
                  }}
                >
                  <KeyboardBackspaceOutlinedIcon />
                </IconButton> */}
          <div>
            <button
              className="back-to-services-btn"
              onClick={backtoHome}
            >
              <i className='pi pi-arrow-left'></i> Home
            </button>
          </div>
        </div>
        <div className="center-heading">
          <h1 style={{ textAlign: 'center' }}>Cancellation & Refund Policy</h1>
        </div>
        <div className="frontend-container">
          <div className="event-form-inner">


            <div className="event-form-body alter full">
              <div className="event-form-content">
                <Typography
                  variant="body1"
                  component="div"
                  style={{ whiteSpace: "pre-line", lineHeight: 1.7 }}
                >
                  {`For International buyers, orders are shipped and delivered through registered international courier companies and/or 
                  International speed post only. For domestic buyers, orders are shipped through registered domestic courier companies and /or 
                  speed post only. Orders are shipped within Not Applicable or as per the delivery date agreed at the time of order confirmation and
                   delivering of the shipment subject to Courier Company / post office norms. ${config.companyFullName} is not liable for 
                   any delay in delivery by the courier company / postal authorities and only guarantees to hand over the consignment to the courier
                    company or postal authorities within Not Applicable from the date of the order and payment or as per the delivery date agreed at 
                    the time of order confirmation. Delivery of all orders will be to the address provided by the buyer. Delivery of our services will 
                    be confirmed on your mail ID as specified during registration. For any issues in utilizing our services you may contact our helpdesk on ${phoneNumber || "N/A"} or ${emailAddress}`}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <ConfirmDialog />
    </div>
  );
};

export default Shipping_DeliveryPolicy;
